import React from 'react';

const AuthRedirect = () => {
  
  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: '100vh',
      flexDirection: 'column'
    }}>
      <div style={{ fontSize: '18px', marginBottom: '10px' }}>Processando autenticação...</div>
      <div>Por favor, aguarde.</div>
    </div>
  );
};

export default AuthRedirect;
